import Vue from 'vue'
import { formatAbsoluteDate, formatRelativeDate, formatShortDate, formatShortDateTime } from '@/utils/utils-datetime'

Vue.filter('formatAbsoluteDate', formatAbsoluteDate)
Vue.filter('formatRelativeDate', formatRelativeDate)
Vue.filter('formatShortDate', formatShortDate)
Vue.filter('formatShortDateTime', formatShortDateTime)
